import React, { useState } from "react";
import "./newsandevents.css";

import {
  FaRegListAlt,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaClock,
  FaUserTie,
  FaRegNewspaper,
  FaTwitter,
  FaLinkedin,
  FaFacebookF,
  FaRegBookmark,
  FaShareAlt,
  FaRegBell,
  FaChevronRight,
  FaSearch,
  FaRegCalendarAlt,
  FaRegClock,
  FaRegMap,
  FaUsers,
  FaVideo,
  FaRegBuilding,
  FaRegHandshake,
  FaRegStar,
  FaRegGem,
  FaRegLightbulb,
  FaRegChartBar,
  FaRegCalendarCheck,
  FaRegEye,
  FaRegCheckCircle,
  FaRegArrowAltCircleDown,
  FaRegEnvelope,
  FaRegPaperPlane,
  FaRegHeart
} from "react-icons/fa";

function NewsAndEvents() {
  const [activeTab, setActiveTab] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");

  const featuredNews = {
    id: "featured-1",
    title:
      "Optica International Launches State-of-the-Art Vision Care Network Across Sri Lanka",
    excerpt:
      "In partnership with leading ophthalmologists, we're revolutionizing eye care accessibility with 50 new centers opening across the island.",
    date: "March 15, 2024",
    category: "Industry News",
    author: "Dr. Priyantha Silva",
    readTime: "5 min read"
  };

  const newsItems = [
    {
      id: 1,
      title:
        "New Research Shows Digital Eye Strain Affects 70% of Sri Lankan Office Workers",
      excerpt:
        "Comprehensive study reveals growing concern and introduces preventive measures.",
      date: "March 12, 2024",
      category: "Research",
      author: "Prof. Kamal Perera",
      readTime: "4 min read"
    },
    {
      id: 2,
      title:
        "Optica International Partners with World Vision for Rural Eye Care Initiative",
      excerpt:
        "Mobile eye care units to serve 100+ villages in Northern and Eastern provinces.",
      date: "March 10, 2024",
      category: "Partnership",
      author: "Optica Team",
      readTime: "3 min read"
    },
    {
      id: 3,
      title: "Annual Optical Industry Report 2024: Trends and Predictions",
      excerpt:
        "Comprehensive analysis of Sri Lanka's optical market and future opportunities.",
      date: "March 8, 2024",
      category: "Industry News",
      author: "Market Research Team",
      readTime: "8 min read"
    },
    {
      id: 4,
      title: "Breakthrough in Pediatric Vision Care Announced",
      excerpt:
        "New early detection methods for childhood vision problems show 95% accuracy.",
      date: "March 5, 2024",
      category: "Innovation",
      author: "Dr. Malini Fernando",
      readTime: "6 min read"
    }
  ];

  const events = [
    {
      id: 1,
      title: "Sri Lanka Optical Conference 2024",
      date: "April 15-17, 2024",
      time: "9:00 AM - 6:00 PM",
      location: "BMICH, Colombo",
      speakers: [
        "Dr. James Wilson (USA)",
        "Dr. Priyantha Silva",
        "Prof. Malathi de Silva"
      ],
      attendees: "500+ Expected",
      status: "registering"
    },
    {
      id: 2,
      title: "Digital Eye Strain Management Workshop",
      date: "March 25, 2024",
      time: "2:00 PM - 5:00 PM",
      location: "Online (Zoom)",
      speakers: ["Dr. Amanda Perera", "Tech. Ruwan Jayasinghe"],
      attendees: "200+ Registered",
      status: "limited"
    }
  ];

  const announcements = [
    {
      id: 1,
      title: "New Member Benefits Package Launch",
      date: "March 14, 2024",
      type: "Membership Update",
      icon: <FaRegGem />
    },
    {
      id: 2,
      title: "Optical Equipment Expo - Call for Exhibitors",
      date: "March 13, 2024",
      type: "Exhibitor Opportunity",
      icon: <FaRegBuilding />
    },
    {
      id: 3,
      title: "Scholarship Applications Now Open",
      date: "March 11, 2024",
      type: "Education",
      icon: <FaRegLightbulb />
    }
  ];

  const categories = [
    { id: "all", label: "All Updates", icon: <FaRegNewspaper /> },
    { id: "news", label: "News", icon: <FaRegNewspaper /> },
    { id: "events", label: "Events", icon: <FaRegCalendarAlt /> },
    { id: "announcements", label: "Announcements", icon: <FaRegBell /> }
  ];

  const getStatusBadge = (status) => {
    switch (status) {
      case "registering":
        return (
          <span className="status-badge registering">
            <FaRegCheckCircle /> Register Now
          </span>
        );
      case "limited":
        return (
          <span className="status-badge limited">
            <FaUsers /> Limited Seats
          </span>
        );
      default:
        return null;
    }
  };

  return (
    <div className="news-events-container">

      {/* HERO */}
      <section className="news-hero">
        <h1>
          News & <span>Events</span>
        </h1>

        <div className="hero-search">
          <FaSearch />
          <input
            type="text"
            placeholder="Search news or events..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </section>

      <section className="news-content">

        {/* SIDEBAR */}
        <aside className="news-sidebar">

          <div className="sidebar-card">
            <h3>
              <FaRegListAlt /> Categories
            </h3>

            <ul>
              {categories.map((cat) => (
                <li
                  key={cat.id}
                  className={activeTab === cat.id ? "active" : ""}
                  onClick={() => setActiveTab(cat.id)}
                >
                  {cat.icon} {cat.label}
                </li>
              ))}
            </ul>
          </div>

          <div className="sidebar-card social">
            <h3>Connect</h3>

            <div className="social-links">
              <a href="#">
                <FaFacebookF />
              </a>
              <a href="#">
                <FaLinkedin />
              </a>
              <a href="#">
                <FaTwitter />
              </a>
            </div>
          </div>

        </aside>

        {/* MAIN FEED */}
        <main className="news-feed">

          {/* FEATURED */}
          {activeTab === "all" && (
            <div className="featured-card">
              <h2>{featuredNews.title}</h2>
              <p>{featuredNews.excerpt}</p>

              <div className="meta">
                <span>
                  <FaCalendarAlt /> {featuredNews.date}
                </span>
                <span>
                  <FaUserTie /> {featuredNews.author}
                </span>
                <span>
                  <FaClock /> {featuredNews.readTime}
                </span>
              </div>

              <button className="read-btn">
                Read More <FaChevronRight />
              </button>
            </div>
          )}

          {/* NEWS */}
          {(activeTab === "all" || activeTab === "news") && (
            <div className="news-grid">

              {newsItems.map((item) => (
                <article key={item.id} className="news-card">
                  <h3>{item.title}</h3>
                  <p>{item.excerpt}</p>

                  <div className="news-meta">
                    <span>
                      <FaCalendarAlt /> {item.date}
                    </span>
                    <span>
                      <FaClock /> {item.readTime}
                    </span>
                  </div>

                  <div className="news-actions">
                    <button>
                      <FaRegBookmark />
                    </button>

                    <button>
                      <FaShareAlt />
                    </button>
                  </div>
                </article>
              ))}

            </div>
          )}

          {/* EVENTS */}
          {(activeTab === "all" || activeTab === "events") && (
            <div className="events-list">

              {events.map((event) => (
                <div key={event.id} className="event-card">

                  <h3>{event.title}</h3>

                  <div className="event-info">
                    <span>
                      <FaCalendarAlt /> {event.date}
                    </span>
                    <span>
                      <FaClock /> {event.time}
                    </span>
                    <span>
                      <FaMapMarkerAlt /> {event.location}
                    </span>
                  </div>

                  <p className="speakers">
                    <FaUserTie /> {event.speakers.join(", ")}
                  </p>

                  <div className="event-footer">
                    <span>
                      <FaUsers /> {event.attendees}
                    </span>

                    {getStatusBadge(event.status)}
                  </div>

                </div>
              ))}

            </div>
          )}

          {/* ANNOUNCEMENTS */}
          {(activeTab === "all" || activeTab === "announcements") && (
            <div className="announcements">

              {announcements.map((a) => (
                <div key={a.id} className="announcement">
                  {a.icon}

                  <div>
                    <h4>{a.title}</h4>
                    <span>
                      <FaCalendarAlt /> {a.date}
                    </span>
                  </div>

                  <FaChevronRight />
                </div>
              ))}

            </div>
          )}

          {/* LOAD MORE */}
          <div className="load-more">
            <button>
              <FaRegArrowAltCircleDown /> Load More
            </button>
          </div>

        </main>

      </section>

      {/* NEWSLETTER */}
      <section className="newsletter-section">

        <h2>
          <FaRegEnvelope /> Subscribe
        </h2>

        <form className="newsletter-form">
          <input type="email" placeholder="Enter email" />
          <button>
            <FaRegPaperPlane /> Subscribe
          </button>
        </form>

        <p>
          <FaRegHeart /> We respect your privacy
        </p>

      </section>

    </div>
  );
}

export default NewsAndEvents;